var AvatarGroupBuilder = /** @class */ (function () {
    function AvatarGroupBuilder() {
        this.group = {
            id: 'bboob0b0b0-boobob-21300321-0b0b0b',
            name: 'bob group'
        };
    }
    AvatarGroupBuilder.prototype.withId = function (id) {
        this.group.id = id;
        return this;
    };
    AvatarGroupBuilder.prototype.withName = function (name) {
        this.group.name = name;
        return this;
    };
    AvatarGroupBuilder.prototype.build = function () {
        return this.group;
    };
    return AvatarGroupBuilder;
}());
export { AvatarGroupBuilder };
//# sourceMappingURL=avatar-group.js.map